import { food_menu_api} from "../constants";
import { Link } from "react-router-dom";
// import { i } from "./RestaurantMenu";
import { useParams } from "react-router-dom";
const RestaurantCard = (props) =>{
     
     const params = useParams();
     const { id } = params;

     return (
          <Link to={"/restaurant/" + Math.floor(Math.random() * 61)}  key={food_menu_api[id]?.id}>
               <div 
               // className="card"
               className="m-4 p-4 w-[310px] h-90 bg-red-50 hover:bg-red-100"
               >
               <img
               className="w-[280px] h-48 rounded-lg" 
               src={"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/" + props.info?.cloudinaryImageId} alt="" />
               <h2 className="font-bold text-xl py-4"> {props.info?.name} </h2>
               <h3> {props.info?.cuisines.join(", ")} </h3>
               <h4> {props.info?.avgRating} stars</h4>
               <h4>{props.info?.costForTwo}</h4>
               <h5>Total Orders: {props.info?.totalRatingsString}</h5>
          </div>
          </Link>
     );
};

// higher order component
export const withPromtedLabel = (RestaurantCard) =>{
     return (props)=>{
          return(
               <div>
                    <label className="absolute bg-slate-600 rounded-lg text-white m-2 p-2">Promoted</label>
                    <RestaurantCard {...props}/>
               </div>
          );
     };
};

export default RestaurantCard;